import { useTranslation } from 'next-i18next'
import { createContext, PropsWithChildren } from 'react'
import { useSortBy } from 'react-instantsearch'
import { defaultSortBy } from 'containers/meilisearchClient'

interface SortByContext {
  currentRefinement: string
  options: ReturnType<typeof useSortBy>['options']
  refine: (value: string) => void
}

export const SortByContext = createContext<SortByContext>({
  currentRefinement: defaultSortBy,
  options: [],
  refine: () => {}
})

export const SortByProvider = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation('common')

  const { currentRefinement, options, refine } = useSortBy({
    items: [
      {
        value: defaultSortBy,
        label: t('event.sortBy.instant_buy')
      },
      {
        value: 'fra_events:editionLiveStartDateTimestamp:asc',
        label: t('event.sortBy.ascending_date')
      },
      {
        value: 'fra_events:editionLiveStartDateTimestamp:desc',
        label: t('event.sortBy.descending_date')
      },
      { value: 'fra_events', label: t('event.sortBy.pertinence') }
    ]
  })

  const value = { currentRefinement, options, refine }
  return (
    <SortByContext.Provider value={value}>{children}</SortByContext.Provider>
  )
}
